<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form"/>
      <h2 class="mb-0">
        {{ 'tramites.tramite-ica.titulo' | translate: { proceso: proceso, entidad: entidad } }}
      </h2>
    </div>
  </div>
  <app-recuadro-justino></app-recuadro-justino>
  <div class="mt-5 border__form">
    <app-form
      [title]="comunText['tipo-demandante']"
      [fields]="formTipoPersonaDemandante"
      [withSubmitButton]="false"
      (changeAction)="onChangeTipoPersonaDemandante($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      *ngIf="tipoPersonaDemandante === 1"
      [title]="comunText['demandante-natural']"
      [withSubmitButton]="false"
      [fields]="formPersonaNaturalDemandante"
      (changeAction)="changePersonaNaturalDemandante($event)"
      (changedControl)="onChangePersonaNaturalDemandante($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      *ngIf="tipoPersonaDemandante === 2"
      [title]="comunText['demandante-juridico']"
      [withSubmitButton]="false"
      [fields]="formPersonaJuridicaDemandante"
      (changeAction)="onChangePersonaJuridicaDemandante($event)"
      (changedControl)="changeControlPersonaJuridicaDemandante($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      [title]="icaText['tramite-ica']['apoderado-proceso']"
      [withSubmitButton]="false"
      [fields]="formApoderadoTramite"
      (changeAction)="onChangeApodeardoTramite($event)"
      (changedControl)="changeApoderadoTramite($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      [title]="comunText['tipo-demandado']"
      [fields]="formTipoPersonaDemandanda"
      [withSubmitButton]="false"
      (changeAction)="onChangeTipoPersonaDemandada($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      *ngIf="tipoPersonaDemandanda === 1"
      [title]="icaText['tramite-ica']['demandando-natural']"
      [withSubmitButton]="false"
      [fields]="formPersonaNaturalDemandada"
      (changeAction)="onChangePersonaNaturalDemandado($event)"
      (changedControl)="changePersonaNaturalDemandado($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      *ngIf="tipoPersonaDemandanda === 2"
      [title]="icaText['tramite-ica']['demandado-juridico']"
      [withSubmitButton]="false"
      [fields]="formPersonaJuridicaDemandada"
      (changeAction)="onChangePersonaJuridicaDemandado($event)"
      (changedControl)="changePersonaJuridicaDemandado($event)"
      [idEntidad]="entidadId"></app-form>

    <app-form
      [title]="comunText['detalle-solicitud']"
      [fields]="formDetalleSolicitud"
      [withSubmitButton]="false"
      (changeAction)="onChangeDetalleSolicitud($event)"
      (changedControl)="changeDetalleSolicitud($event)"
      [idEntidad]="entidadId"></app-form>

    <div class="my-3">
      <h4 class="wrapper__form__title color__cobalt">
        {{ comunText['anexos'] }}
      </h4>
      <app-cargue-archivos-tramite
        *ngIf="mostrarComponenteCarga"
        [archivosPreCargados]="archivosPreCargados"
        [idTipoTramite]="tipoTramite"
        [idTramite]="idTramiteObtentorVariedadVegetal"
        [enviar]="enviarDocumentos"
        [enviarEntidad]="enviarEntidad"
        [nombreCortoTramite]="nombreTramite"
        (archivosCargados)="archivosCargados($event)"
        (archivosValidados)="archivosValidados($event)"
        (guardo)="archivosGuardados($event)">
      </app-cargue-archivos-tramite>
      <div class="mt-3 text-muted small d-flex align-items-center">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
      </div>
    </div>
    <div class="mt-3 p-3 border bg-light" *ngIf="!validacionTodosFormularios()">
      <div class="alert alert-info">
        <p>
          <strong>{{ 'confirmacion_envio.titulo' | translate }}</strong>
          {{ 'confirmacion_envio.mensaje' | translate }}
        </p>
        <p class="fst-italic">
          {{ 'confirmacion_envio.nota' | translate }}
        </p>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="confirmacionEnvio"
          [(ngModel)]="confirmacionEnvio"
        />
        <label class="form-check-label" for="confirmacionEnvio">
          {{ 'confirmacion_envio.checkbox' | translate }}
        </label>
      </div>
    </div>

    <div *ngIf="confirmacionEnvio" class="border p-4 mt-4 bg-white shadow-sm rounded">
      <h5 class="wrapper__form__title mb-0">
        {{ 'copia_envio.desea_enviar_copia' | translate }}
      </h5>

      <p>
        {{ 'copia_envio.descripcion' | translate:{ correo: correoDemandado, nombre: nombreDemandado } }}
      </p>

      <div class="d-flex gap-2 mt-3">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="rechazarEnvio()"
          [attr.aria-label]="'copia_envio.rechazar' | translate">
          {{ 'copia_envio.rechazar' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="aceptarEnvio()"
          [attr.aria-label]="'copia_envio.aceptar' | translate">
          {{ 'copia_envio.aceptar' | translate }}
        </button>
      </div>


    </div>

    <div class="col-12 d-flex justify-content-end mt-3">
      <div class="d-flex flex-column flex-md-row gap-2">
        <button
          class="btn-govco fill-before-btn-govco w-auto"
          (click)="onSubmitGuardar()"
          [attr.aria-label]="icaText['botones-envio']['guardar-sin-enviar']">
          {{ icaText['botones-envio']['guardar-sin-enviar'] }}
        </button>
        <button
          class="btn-govco fill-send-govco w-auto"
          (click)="onSubmitCompiladoFormularios(true)"
          [attr.aria-label]="icaText['botones-envio']['enviar']">
          {{ icaText['botones-envio']['enviar'] }}
        </button>
      </div>
    </div>
  </div>
</div>
